import React, { Component } from "react";
import { connect } from "react-redux";
import { userInRole, userInRoles } from "../services/authService";
import PropTypes from "prop-types";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import { Link } from "react-router-dom";

class NavItem extends Component {
  render() {
    const {
      router,
      path,
      title,
      icon: Component,
      requiredRoles,
      user
    } = this.props;

    let hasRequiredRole = false;
    if (requiredRoles) {
      hasRequiredRole = userInRoles(user, requiredRoles);
    }

    return !requiredRoles || hasRequiredRole ? (
      <ListItem
        button
        component={Link}
        to={path}
        selected={router.location.pathname === path}
      >
        <ListItemIcon>
          <Component />
        </ListItemIcon>
        <ListItemText inset primary={title} />
      </ListItem>
    ) : null;
  }
}

NavItem.propTypes = {
  router: PropTypes.object.isRequired,
  path: PropTypes.string.isRequired,
  user: PropTypes.object.isRequired
};

function mapStateToProps(state) {
  return {
    router: state.router,
    user: state.user.user
  };
}

export default connect(mapStateToProps)(NavItem);
